import React from 'react'
import { useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { useNavigate } from "react-router-dom"

function MagicWord() {

    const [magicWord, setMagicWord] = useState('');
    let navigate = useNavigate();

    const postData = () => {
      axios.post('https://63c9b718904f040a966397d6.mockapi.io/magicWord', {
      magicWord
    }).then(() => {
        navigate('/accueil')
    })
  }

  return(
    <>
    <h1 style={{textAlign:"center", fontSize:"40px"}}>SIGN UP</h1>
  <form className="create-form">
      <label>MagicWord</label>
      <input 
      placeholder='MagicWord'
      onChange={(e) => setMagicWord(e.target.value)}
       />
    <button
    type='submit'
    onClick={postData}
    >Submit</button>
    <Link to='/accueil'>RETOUR</Link>
  </form>
  </>
  )
  }

export default MagicWord